import { forwardRef, useMemo } from "react";
import { SelectInstance } from "react-select";
import { RefType } from "../../../../types";
import { genericMemo } from "../../../../utils";
import { SimpleSelect, SimpleSelectOptionType, SimpleSelectProps } from "../SimpleSelect";

export type YearSelectProps<IsMulti extends boolean = boolean> = Omit<SimpleSelectProps<number, IsMulti>, "options"> & {
  reverse?: boolean,
  min?: number,
  max?: number,
}

const YearSelectComponent = <IsMulti extends boolean = boolean>(props: YearSelectProps<IsMulti>) => <></>;
export type YearSelectComponentType = typeof YearSelectComponent;

export const YearSelect = genericMemo(forwardRef(<IsMulti extends boolean = boolean>(
  {
    reverse = true,
    min = new Date().getFullYear() - 51,
    max = new Date().getFullYear(),
    ...props
  }: YearSelectProps<IsMulti>,
  ref: RefType<SelectInstance<SimpleSelectOptionType<number>, IsMulti>>,
) => {
  const options = useMemo(() => {
    const newOptions = Array.from({ length: max - min }, (v, k) => min + k + 1);
    return reverse ? newOptions.reverse() : newOptions;
  }, [ min, max, reverse ]);

  return (
    <SimpleSelect<number, IsMulti>
      placeholder="XXXX"
      {...props}
      options={options}
      ref={ref}
    />
  );
}) as YearSelectComponentType);


